import Api from "./ApiNode";

export default {
  getTimelineLog(payload, config) {
    console.log("Fetching timeline log with payload:", payload);
    let getTimelineData = Api().post(
      "master/logs/timeline-log",
      payload,
      config,
    );
    return getTimelineData;
  },
};



// WEBPACK FOOTER //
// ./src/services/LogManagementService.js